module.exports = __webpack_public_path__ + "static/media/med_slide1.496da023.jpg";